import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withFirebase } from "../Firebase";
import { Box, Flex, Text } from "rebass";
import { Avatar } from "reakit";
import { FacultyPositionContainer } from "../Base/styles";
import { schoolActions, schoolSelectors } from "../../store/school";
import { authActions, authSelectors } from "../../store/auth";

import IosCheckmarkCircle from "react-ionicons/lib/IosCheckmarkCircle";

import { CardWrapper } from "./styles";

const withBorder = {
  pb: [0, 2],
  my: [2, 0],
  borderBottom: `1px solid #DEDDDD`,
};

const noBorderProps = {
  borderBottom: "none",
};

const columnBorderProps = {
  m: 2,
  pb: [0, 2],
  my: [2],
  // width: 170px;
  // height: '170px'
  boxShadow: ["none", "main"],
};

const selectedBorderProps = {
  borderRight: ["none", "7px solid #2b80b9"],
};

class FacultyCard extends Component {
  state = {
    locations: [],
    history: [],
    map: null,
    details: { first_name: "", last_name: "", location: "", id: 1 },
  };

  componentDidMount() {
    const { details } = this.props;
    this.setState({ details });
    if (details.id.length === 7) {
      this.listener = this.fetchStudentListener(details.id);
    } else {
      this.listener = this.fetchFacultyListener(details.id);
    }
  }

  fetchStudentListener = (id) => {
    return this.props.firebase.student(id).onSnapshot((snapshot) => {
      this.setState({ details: { id: snapshot.id, ...snapshot.data() } });
    });
  };

  fetchFacultyListener = (id) => {
    return this.props.firebase.faculty(id).onSnapshot((snapshot) => {
      this.setState({ details: { id: snapshot.id, ...snapshot.data() } });
    });
  };

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextProps.details !== this.props.details) {
      this.setState({ details: nextProps.details });
      if (nextProps.details.id.length === 7) {
        this.listener = this.fetchStudentListener(nextProps.details.id);
      } else {
        this.listener = this.fetchFacultyListener(nextProps.details.id);
      }
    }
  }

  componentWillUnmount() {
    this.listener && this.listener();
  }

  render() {
    const { details } = this.state;
    const {
      studentSummary,
      noBorder,
      handleClick,
      selected,
      columnView,
      current,
      chatPopupWindow,
    } = this.props;
    let cardProps = withBorder;
    if (noBorder) {
      cardProps = noBorderProps;
    }
    if (!columnView) {
      cardProps = columnBorderProps;
    }
    let currentDetail = current;

    if (currentDetail === details.id && columnView === true) {
      cardProps = { ...cardProps, ...selectedBorderProps };
    }

    return (
      <CardWrapper
        minWidth={[
          1 / 3,
          chatPopupWindow ? "50px" : columnView ? "200px" : "153px",
        ]}
        maxWidth={[1 / 3, "200px"]}
        minHeight={[
          1 / 3,
          chatPopupWindow ? "135px" : columnView ? "70px" : "153px",
        ]}
        maxHeight={[1 / 3, columnView ? "70px" : "153px"]}
        style={chatPopupWindow ? { margin: 0 } : {}}
        variant="user"
        onClick={(e) => handleClick(details, e)}
        {...cardProps}
      >
        <Flex
          flexWrap={"wrap"}
          flexDirection={["column", columnView ? "row" : "column"]}
        >
          <Flex>
            <Box ml={"auto"} />
            {/*<DesktopBox>*/}
            <IosCheckmarkCircle
              style={{ marginTop: "3px" }}
              color={!columnView && selected ? "#2b80b9" : "white"}
            />
            {/*</DesktopBox>*/}
          </Flex>
          <Box width={[1, "auto"]}>
            <Flex flexDirection={"column"}>
              <Flex justifyContent={"center"}>
                <Avatar
                  src={details.profile_pic}
                  width={"60px"}
                  height={"60px"}
                  backgroundColor={"#707070"}
                />
              </Flex>
            </Flex>
          </Box>
          <Box width={columnView ? "65%" : [1, "auto"]} pl={columnView ? 2 : 0}>
            <Text
              textAlign={studentSummary ? "left" : "center"}
              fontSize={studentSummary ? "20px" : "15px"}
              fontWeight="600"
              pt={2}
            >
              {details.first_name} {details.last_name}
            </Text>
            {columnView ? <FacultyPositionContainer bg="#2b80b9" color="#fff">
                  <Text
                    textAlign={studentSummary ? "left" : "center"}
                    fontSize={studentSummary ? "20px" : "15px"}
                    fontWeight="600"
                    color="white"
                  >
                    {details.position && details.position.length > 30 ? details.position.substring(0, 30) + '...' : details.position}
                  </Text>
                </FacultyPositionContainer> : ''}
          </Box>
          {!columnView ? 
            <Box width={[1, "auto"]} pl={columnView ? 2 : 0}>
              {details && details.position && (
                <FacultyPositionContainer bg="#2b80b9" color="#fff">
                  <Text
                    textAlign={studentSummary ? "left" : "center"}
                    fontSize={studentSummary ? "20px" : "15px"}
                    fontWeight="600"
                    color="white"
                  >
                    {details.position && details.position.length > 30 ? details.position.substring(0, 30) + '...' : details.position}
                  </Text>
                </FacultyPositionContainer>
              )}
            </Box> : ''
          }
        </Flex>
      </CardWrapper>
    );
  }
}

FacultyCard.propTypes = {
  noBorder: PropTypes.bool,
  withLocation: PropTypes.bool,
  handleClick: PropTypes.func,
  details: PropTypes.object,
  selected: PropTypes.bool,
  columnView: PropTypes.bool,
  rosterList: PropTypes.bool,
  studentSummary: PropTypes.bool,
};

FacultyCard.defaultProps = {
  noBorder: false,
  withLocation: false,
  selected: false,
  columnView: true,
  studentSummary: false,
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  loadingSchool: schoolSelectors.isLoading(state.school),
  profileInfo: authSelectors.refreshProfile(state.auth),
  loading: authSelectors.isLoading(state.auth),
  isFaculty: authSelectors.isFaculty(state.auth),
});

const mapDispatchToProps = (dispatch) => ({
  updateSchoolInfo: (data) => {
    dispatch(schoolActions.updateSchoolInfo(data));
  },
  updateProfileInfo: (data) => {
    dispatch(authActions.updateProfileInfo(data));
  },
});

export default withFirebase(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FacultyCard)
);
